/*************************************************/
/* TEXTSLIDER                                    */
/*************************************************/
export function textSlider() {
    const slidingTexts = document.querySelectorAll('.text-slider__sliding-text');
    const slidingContainer = document.querySelector('.text-slider__sliding-container');

    const itemCount = slidingTexts.length;
    const itemDuration = 2;


    const init = () => {
        if (!slidingContainer) {
            return; // Exit if the container is not present
        }
        // Set CSS variables
        slidingContainer.style.setProperty('--items', itemCount);
        slidingContainer.style.setProperty('--duration', `${itemDuration}s`);
        slidingContainer.style.setProperty('--total-duration', `${itemCount * itemDuration}s`);

        // Apply dynamic delay to each text item based on its index
        slidingTexts.forEach((text, index) => {
            text.style.animationDuration = `${itemCount * itemDuration}s`;
            text.style.animationDelay = `${index * itemDuration}s`;
        });
    };

    init();
}